var map = {
	"./facebook-white.svg": "ae75",
	"./google-white.svg": "0a38",
	"./linkedin-white.svg": "34aa",
	"./logo-bayton-hr-white.svg": "7968",
	"./logo-bayton-mktg-white.svg": "9b70",
	"./logo-bayton-os-white.svg": "a3b7",
	"./logo-bayton-tech-white.svg": "08a6",
	"./twitter-white.svg": "3892"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88a1";